/**
 * The read layer, in tiers (§12). Confidence is a number the sim computes;
 * how flat or vague it renders is tuning, so the tier is decided here and
 * the UI only chooses words for it.
 */

import { TUNING } from './tuning.js';
import type { NpcReadLayer, RelationshipAxes } from './types/index.js';

/** blind: one vague line. hazy: hedged. clear: flat statements. */
export type ReadClarity = 'blind' | 'hazy' | 'clear';

export function readClarity(read: NpcReadLayer): ReadClarity {
  if (read.confidence < TUNING.read.blind) return 'blind';
  if (read.confidence < TUNING.read.hazy) return 'hazy';
  return 'clear';
}

export type Axis = keyof RelationshipAxes;

/** The axes strong enough to be worth a sentence, in display order. Sign included. */
export function readSignals(read: NpcReadLayer): readonly { readonly axis: Axis; readonly positive: boolean }[] {
  const order: readonly Axis[] = ['trust', 'warmth', 'respect', 'fear'];
  const out: { axis: Axis; positive: boolean }[] = [];
  for (const axis of order) {
    const v = read.relationship[axis];
    if (Math.abs(v) < TUNING.read.faint) continue;
    // Not being afraid is the resting state; only say so when it's news.
    if (axis === 'fear' && v < 0) continue;
    out.push({ axis, positive: v > 0 });
  }
  return out;
}
